import WebApp from "@twa-dev/sdk";

export const telegram = WebApp;

export const getInitData = (): string => {
  return WebApp.initData;
};

export const getUserInfo = () => {
  return WebApp.initDataUnsafe?.user;
};

export const getStartParam = (): string | undefined => {
  return WebApp.initDataUnsafe?.start_param;
};

export const hapticFeedback = {
  light: () => WebApp.HapticFeedback?.impactOccurred("light"),
  medium: () => WebApp.HapticFeedback?.impactOccurred("medium"),
  heavy: () => WebApp.HapticFeedback?.impactOccurred("heavy"),
  success: () => WebApp.HapticFeedback?.notificationOccurred("success"),
  error: () => WebApp.HapticFeedback?.notificationOccurred("error"),
  warning: () => WebApp.HapticFeedback?.notificationOccurred("warning"),
  selectionChanged: () => WebApp.HapticFeedback?.selectionChanged(),
};

export const showConfirm = (message: string): Promise<boolean> => {
  return new Promise((resolve) => {
    WebApp.showConfirm(message, resolve);
  });
};

export const closeMiniApp = () => {
  WebApp.close();
};

export const expandMiniApp = () => {
  WebApp.expand();
};

export const enableBackButton = (callback: () => void) => {
  WebApp.BackButton.show();
  WebApp.BackButton.onClick(callback);
  return () => {
    WebApp.BackButton.offClick(callback);
    WebApp.BackButton.hide();
  };
};

export const setHeaderColor = (color: string) => {
  try {
    WebApp.setHeaderColor(color as `#${string}`);
  } catch {
    // Fallback for older versions
  }
};
